__turbopack_context__.v({
  "icon": "styles-module__ARAzIG__icon",
  "phoneLink": "styles-module__ARAzIG__phoneLink",
});
